import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ApiGo from '../../../actions/ApiGo';
import { ADD_RESPONSE } from '../../../stores/reducer_add';
import Unit from './Unit';

const Institution =(props)=>{
    const {t, i18n} = useTranslation()
    const [institutionSelc, setInstitutionSelc] = useState(0);
    const [institutions, setInstitutions] = useState([]);
    const [refresh, setRefresh] = useState(false);
    function toggleRefresh(){ setRefresh(!refresh)}
    const [addUserBtn, setAddUserBtn] = useState(false);
    function toggleAddUsers(){ setAddUserBtn(!addUserBtn) }
    const [inputIns, setInputIns] = useState("");
    const dispatch = useDispatch()

    useEffect(() => {
        ApiGo.institutioncheck()
        .then(res=>{
            setInstitutions(res)
            setInputIns("")
        })
        .catch(err=>{console.log(err);})
    }, [refresh]);

    function deleteInstitution(_ins){
        var confirm_info = window.confirm( `是否刪除機構? ` )
        if(!confirm_info){return}
        ApiGo.deletInstitution(_ins)
        .then(()=>{dispatch(ADD_RESPONSE({status:200, statusText:"success", type:"delete_Institution"}));toggleRefresh()})
        .catch(err=>{dispatch(ADD_RESPONSE({status:err.status, statusText:err.statusText, type:"delete_Institution"})) })
    }
    function setToDefault(_ins){
       localStorage.setItem('institution', _ins)
    }
    // function createInstitution(_inputIns){
    //     ApiGo.create_institution(_inputIns)
    //     .then(res=>{dispatch(ADD_RESPONSE({status:200, statusText:"success", type:"create_Institution"}));toggleRefresh()})
    //     .catch(err=>{dispatch(ADD_RESPONSE({status:err.status, statusText:err.statusText, type:"create_Institution"}))})
    // }

    let institution_div = institutions.map(institution=><div
            className={`w-10 font-ml selcBox fx-d-r fx-cspar ${institutionSelc===institution.id?"selced shadow-s-nohover":""}`}
            onClick={()=>{setInstitutionSelc(institution.id)}}
            key={institution.id}>
            <div className='fx-ccc'>{institution.name}</div>
            {/* <div className=' w-20 fx-ccc'>
                <div onClick={()=>{setToDefault(institution.institution)}} className='bgC-alert-E br-5 pad-15 l r shadow-xs cursor pt margl-xs'>{t("ADMIN.OTHER_PAGE.SET_DEFAULT_INSTITUTION")}</div>
            </div>
            <div className=' w-20 fx-ccc'>
                <div onClick={()=>{deleteInstitution(institution.institution)}} className='bgC-alert-EE br-5 pad-15 l r shadow-xs cursor pt margl-xs'>{t("RESIDENTS.DELETE")}</div>
            </div> */}
        </div>)

    return(
        <div className='w-100 h-100 fx-d-c institution'>
            {/* <div className='w-50 font-l fx-d-r margb-xxs fx-fsc'>
                <div className='margr-s'>{t("GLOBAL.ADD_INSTITUTUION")}</div>
                <div className=' margr-s'><input className='border-dark br-10 bgC-white' onChange={e=>{setInputIns(e.target.value)}} value={inputIns} /></div>
                <div onClick={()=>{createInstitution(inputIns); toggleAddUsers();}} className='w-10 bgC-alert-E br-10 fx-ccc shadow-xs pad-45 l r'>+</div>
            </div> */}
            <div className='fx-d-r'>
                {institution_div}
            </div>
            <Unit />
        </div>
    );


}
export default Institution;